import { render } from "./MonthCalendar.vue?vue&type=template&id=6d660e38"
import script from "./MonthCalendar.vue?vue&type=script&lang=js"
export * from "./MonthCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__